<template>
  <div class="container-fluid">
  
  </div>
  <!-- END MAIN CONTENT-->
</template>
<script>
export default {
  name: 'MainContent',
}
</script>